import { Pipe, PipeTransform } from '@angular/core';
import { ReadingStatus } from '../models/meterReading.model';

@Pipe({
  name: 'getReadingStatusClass'
})
export class GetReadingStatusClassPipe implements PipeTransform {
  transform(value: any, translation: boolean = false): any {
    switch (value) {
      case (ReadingStatus.Assigned):
      case "Assigned":
      case 0:
        return translation ? 'READING.READING_STATUS.USAGE' : 'Usage';
      case (ReadingStatus.Submitted):
      case "Submitted":
      case 1:
        return translation ? 'READING.READING_STATUS.USAGE' : 'Usage';
      case (ReadingStatus.Failed):
      case "Failed":
      case 2:
        return translation ? 'READING.READING_STATUS.FAILED' : 'Failed';
      case (ReadingStatus.Rejected):
      case "Rejected":
      case 3:
        return translation ? 'READING.READING_STATUS.REJECTED' : 'Rejected';
      case (ReadingStatus.Inaccessible):
      case "Inaccessible":
      case 4:
        return translation ? 'READING.READING_STATUS.INACCESSIBLE' : 'Inaccessible';
      case (ReadingStatus.Inoperable):
      case "Inoperable":
      case 5:
        return translation ? 'READING.READING_STATUS.INOPERABLE' : 'Inoperable';
      default:
        return translation ? 'READING.READING_STATUS.UNKNOWN' : 'Unknown status.';
    }
  }
}
